import React, { useState } from "react";
import ReactDOMServer from "react-dom/server";

// A separate component for the report's content to facilitate printing
const LoadingPlanReportContent = ({ reportData }) => {
  const { Header, BillTo, ShipTo, Supplier, Order, Items, Total } = reportData;

  const style = {
    fontFamily: "Arial, sans-serif",
    fontSize: "10px", // Uniform font size for the entire report
    border: "1px solid #000",
    padding: "5px",
  };

  return (
    <div
      className="report-page"
      style={{
        width: "210mm",
        minHeight: "297mm",
        margin: "0 auto",
        boxSizing: "border-box",
        border: "1px solid #ccc",
        padding: "10mm 15mm",
      }}
    >
      <table style={{ ...style, borderCollapse: "collapse", width: "100%" }}>
        {/* Header Section */}
        <tr style={{ borderBottom: "2px solid #000" }}>
          <td style={{ ...style, width: "20%", border: "none" }}>
            <img src="/path/to/your/fsc-logo.png" alt="FSC Logo" style={{ width: "80px", marginBottom: "5px" }} />
            <p style={{ margin: 0, whiteSpace: "nowrap" }}>
              www.fsc.org<br/>
              FSC® C210691<br/>
              The mark of responsible forestry
            </p>
          </td>
          <td style={{ ...style, width: "60%", textAlign: "center", border: "none" }}>
            <h3 style={{ margin: "0", fontSize: "14px", whiteSpace: "nowrap" }}>KK Duplex & Paper Mills Private Limited</h3>
            <div style={{ whiteSpace: "nowrap" }}>{Supplier.Address}</div>
            <div style={{ whiteSpace: "nowrap" }}>Email ID: sales@kkduplex.com</div>
            <div style={{ whiteSpace: "nowrap" }}>GSTIN: {Supplier.GSTIN}</div>
          </td>
          <td style={{ ...style, width: "20%", textAlign: "right", border: "none" }}>
            <h4 style={{ margin: "0", fontSize: "14px" }}>Loading Plan</h4>
          </td>
        </tr>

        {/* Plan Details Section */}
        <tr>
          <td colSpan="3" style={{ ...style, padding: "0" }}>
            <table style={{ borderCollapse: "collapse", width: "100%" }}>
              <tr>
                <td style={{ ...style, border: "none", width: "33%" }}>
                  <strong>Despatch Plan No</strong>: {Header.DespatchPlanNo}
                </td>
                <td style={{ ...style, border: "none", width: "33%" }}>
                  <strong>Truck Number</strong>: {Header.TruckNumber}
                </td>
                <td style={{ ...style, border: "none", width: "33%" }}>
                  <strong>Revision</strong>: {Header.Revision}
                </td>
              </tr>
              <tr>
                <td style={{ ...style, border: "none" }}>
                  <strong>Date</strong>: {Header.Date}
                </td>
                <td style={{ ...style, border: "none" }} colSpan="2"></td>
              </tr>
            </table>
          </td>
        </tr>

        {/* Addresses Section */}
        <tr>
          <td colSpan="3" style={{ ...style, padding: "0" }}>
            <table style={{ borderCollapse: "collapse", width: "100%" }}>
              <tr>
                <td style={{ ...style, width: "50%", verticalAlign: "top" }}>
                  <h4>Bill To</h4>
                  <strong>Parent:</strong> {BillTo.Parent}<br/>
                  <strong>Bill to:</strong> {BillTo.Name}
                </td>
                <td style={{ ...style, width: "50%", verticalAlign: "top" }}>
                  <h4>Ship To</h4>
                  <strong>Ship to:</strong> {ShipTo.Name}
                </td>
              </tr>
            </table>
          </td>
        </tr>

        {/* Order Details Section */}
        <tr>
          <td colSpan="3" style={{ ...style, padding: "0" }}>
            <table style={{ borderCollapse: "collapse", width: "100%" }}>
              <tr>
                <td style={{ ...style, width: "33%" }}>
                  <strong>Order No</strong>: {Order.OrderNo}
                </td>
                <td style={{ ...style, width: "33%" }}>
                  <strong>Quality</strong>: {Order.Quality}
                </td>
                <td style={{ ...style, width: "33%" }}>
                  <strong>GSM</strong>: {Order.GSM}
                </td>
              </tr>
            </table>
          </td>
        </tr>

        {/* Items Table */}
        <tr>
          <td colSpan="3" style={{ ...style, padding: "0" }}>
            <table style={{ borderCollapse: "collapse", width: "100%", textAlign: "center" }}>
              <thead>
                <tr>
                  <th style={{ ...style, textAlign: "center", width: "5%" }}>S.No</th>
                  <th style={{ ...style, textAlign: "center", width: "15%" }}>Size (Inch) Location</th>
                  <th style={{ ...style, textAlign: "center", width: "10%" }}>Ream Wt.</th>
                  <th style={{ ...style, textAlign: "center", width: "10%" }}>Reams per Bundle</th>
                  <th style={{ ...style, textAlign: "center", width: "10%" }}>Bundle Weight</th>
                  <th style={{ ...style, textAlign: "center", width: "10%" }}>No of Reels /Bundles</th>
                  <th style={{ ...style, textAlign: "center", width: "15%" }}>Weight (Kg)</th>
                  <th style={{ ...style, textAlign: "center", width: "10%" }}>Picked?</th>
                </tr>
              </thead>
              <tbody>
                {Items.map((item, index) => (
                  <tr key={index}>
                    <td style={{ ...style, textAlign: "center" }}>{item.S_No}</td>
                    <td style={{ ...style }}>{item.Size}</td>
                    <td style={{ ...style }}>{item.Ream_Wt}</td>
                    <td style={{ ...style }}>{item.Reams_per_Bundle}</td>
                    <td style={{ ...style }}>{item.Bundle_Weight}</td>
                    <td style={{ ...style }}>{item.No_of_Reels_Bundles}</td>
                    <td style={{ ...style }}>{item.Weight_Kg}</td>
                    <td style={{ ...style, textAlign: "center" }}>
                      <input type="checkbox" style={{ margin: 0 }} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </td>
        </tr>

        {/* Totals Section */}
        <tr>
          <td colSpan="3" style={{ ...style, padding: "0" }}>
            <table style={{ borderCollapse: "collapse", width: "100%" }}>
              <tr>
                <td style={{ ...style, border: "none", width: "50%", textAlign: "right" }}>
                  <strong>Sub Total (Kg)</strong>:
                </td>
                <td style={{ ...style, border: "none", width: "50%", textAlign: "right" }}>
                  {Total.SubTotalKg}
                </td>
              </tr>
              <tr>
                <td style={{ ...style, border: "none", textAlign: "right" }}>
                  <strong>Grand Total (Kg)</strong>:
                </td>
                <td style={{ ...style, border: "none", textAlign: "right" }}>
                  {Total.GrandTotalKg}
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>

      {/* Footer Section */}
      <table style={{ ...style, border: "none", width: "100%", marginTop: "20px" }}>
        <tr>
          <td style={{ ...style, border: "none", textAlign: "center", width: "33%" }}>
            <p style={{ margin: 0 }}>Prepared By</p>
          </td>
          <td style={{ ...style, border: "none", textAlign: "center", width: "33%" }}>
            <p style={{ margin: 0 }}>Checked By</p>
          </td>
          <td style={{ ...style, border: "none", textAlign: "center", width: "33%" }}>
            <p style={{ margin: 0 }}>For {Supplier.Name}</p>
            <p style={{ margin: "20px 0 0" }}>Authorized Signatories</p>
          </td>
        </tr>
      </table>
    </div>
  );
};

// Main component with state and print button
const DespatchPlanLPReport = () => {
  const defaultReportData = {
    Header: {
      DespatchPlanNo: "DP-196-2025",
      Date: "28-Jul-2025",
      TruckNumber: "HR38AD9477",
      Revision: "0",
    },
    BillTo: {
      Parent: "AS PACKERS PROVIDERS (P) LTD",
      Name: "AS PACKERS PROVIDERS (P) LTD",
    },
    ShipTo: {
      Name: "AS PACKERS PROVIDERS (P) LTD",
    },
    Supplier: {
      Name: "NETIQUE INFOTECH PRIVATE LIMITED",
      Address: "8.5 km, Jansath Road,, Muzaffarnagar UTTAR PRADESH, INDIA 251001",
      GSTIN: "09AABCR1065J1ZC",
    },
    Order: {
      OrderNo: "AP-183-2025",
      Quality: "AURA",
      GSM: "230",
    },
    Items: [
      {
        S_No: 1,
        Size: "23.00 x 25.00",
        Location: "Area:",
        Ream_Wt: 1.90,
        Reams_per_Bundle: 38,
        Bundle_Weight: 72.20,
        No_of_Reels_Bundles: 100,
        Weight_Kg: 7220.000,
      },
    ],
    Total: {
      SubTotalKg: 7220.00,
      GrandTotalKg: 7220.00,
    },
  };

  const [reportData] = useState(defaultReportData);

  const handlePrint = () => {
    const reportHtml = ReactDOMServer.renderToStaticMarkup(
      <LoadingPlanReportContent reportData={reportData} />
    );

    const newWindow = window.open("", "_blank", "width=900,height=700");
    if (!newWindow) {
      alert("Please allow pop-ups for this website to print the report.");
      return;
    }

    newWindow.document.write(`
      <html>
        <head>
          <title>Despatch Plan- Loading Plan</title>
          <style>
            body { font-family: Arial, sans-serif; font-size: 10px; margin: 0; padding: 0; }
            table { border-collapse: collapse; width: 100%; }
            th, td { border: 1px solid #000; padding: 5px; text-align: left; }
            .report-page {
              width: 210mm;
              min-height: 297mm;
              margin: 0 auto;
              padding: 10mm 15mm;
              box-sizing: border-box;
            }
          </style>
        </head>
        <body>
          ${reportHtml}
        </body>
      </html>
    `);
    newWindow.document.close();
    newWindow.focus();
    newWindow.print();
    newWindow.close();
  };

  return (
    <div>
      <h1 style={{ textAlign: "center" }}>Despatch Plan Loading Plan Report</h1>
      <div style={{ textAlign: "center", margin: "20px 0" }}>
        <button
          onClick={handlePrint}
          style={{
            padding: "10px 20px",
            cursor: "pointer",
            border: "none",
            background: "#1976d2",
            color: "#fff",
            borderRadius: "4px",
            fontSize: "14px",
          }}
        >
          Print Loading Plan
        </button>
      </div>
      <LoadingPlanReportContent reportData={reportData} />
    </div>
  );
};

export default DespatchPlanLPReport;